import { watch } from "vue";
import { useTokenStore } from "../stores/token.store";
import { CookieFacade } from "./cookie.facade";

export class TokenFacade {
    private tokenStore = useTokenStore();

    constructor(private cookie: CookieFacade) {}

    public validate() {
        if (import.meta.env.SSR) return;

        watch(
            () => this.tokenStore.token,
            (token) => {
                if (token === undefined) {
                    window.location.replace("/signin");
                }
            },
        );
    }

    public get current() {
        return this.tokenStore.token;
    }

    public login(newToken: string) {
        this.tokenStore.inject(newToken);
        if (import.meta.env.SSR) return;
        this.cookie.set("token", newToken);
    }

    public logout() {
        this.tokenStore.clear();
        if (import.meta.env.SSR) return;
        this.cookie.remove("token");
    }
}
